export const careerPositions = [
  { id: 1, title: "Chef" },
  { id: 2, title: "Waiter / Waitress" },
  { id: 3, title: "Restaurant Manager" },
  { id: 4, title: "Kitchen Helper" },
  { id: 5, title: "Delivery Partner" },
  { id: 6, title: "Cleaner" },
];
